import React from 'react';
import './DevRibbon.scss';

/**
 * DevRibbon component displays a diagonal ribbon in the top-left corner
 * with "dev" text when the application is running in development mode.
 *
 * This matches the Angular implementation's styling with a red/maroon
 * background and white text.
 */
const DevRibbon: React.FC = () => {
    // Only render in development mode
    if (import.meta.env.MODE !== 'development') {
        return null;
    }

    return (
        <div className="dev-ribbon">
            <span className="dev-ribbon-text">dev</span>
        </div>
    );
};

export default DevRibbon;
